import React, { useState } from "react";
import { Helmet } from "react-helmet"; // <-- Added Helmet import
import Navbar from "../components/navbar";
import HeaderSeparator from "../components/HeaderSeparator";
import FlippingCard from "../components/FlippingCard";
import Footer from "../components/footer";
import "../assets/styles/bod.css";

// These imports are for the FlippingCard component, not directly for Helmet
import nitamImage from '../assets/images/team/nitam.png';
// import monikaImage from "../assets/images/team/monika.png";
import abhinabImage from "../assets/images/team/abhinab.png";
import shekharImage from "../assets/images/team/shekhar.jpg";
import vijayaImage from "../assets/images/team/vijaya.png";
import ronikImage from "../assets/images/team/ronik.jpeg";
import ashleshaImage from "../assets/images/team/ashlesha.png";
import siddhantImage from "../assets/images/team/siddhant.jpg";
import nirojImage from "../assets/images/team/niroj.png";
import shrisnaImage from "../assets/images/team/shrisna.jpeg";
import niharikaImage from "../assets/images/team/niharika.jpeg";
// import pratikImage from "../assets/images/team/pratik.jpg";
import blankImage from "../assets/images/team/blank.png";

const BOD = () => {
  const [flippedCardIndex, setFlippedCardIndex] = useState(null);

  const handleFlip = (index) => {
    setFlippedCardIndex(flippedCardIndex === index ? null : index);
  };

  const teamMembers = [
    {
      id: 1,
      frontImage: nitamImage,
      frontName: "Nitamraj Poudel",
      frontTitle: "President",
      backText: (
        <>
          <span className="back-text">Nitamraj Poudel</span>
          {/* <span className="back-text">"Quote"</span> */}
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/nitamraj-poudel/"
              target="_blank"
              rel="noopener noreferrer"
              className="icons linkedin"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=8808&format=png&color=FFFFFF"
                  alt="LinkedIn Icon"
                />
              </div>
              <span>LinkedIn</span>
            </a>

            <a
              href="mailto:nitam@kalpabriksha.org.np"
              target="_blank"
              rel="noopener noreferrer"
              className="icons email"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=OumT4lIcOllS&format=png&color=000000"
                  alt="Email Icon"
                />
              </div>
              <span>Email</span>
            </a>
          </div>
        </>
      ),
    },
    {
      id: 2,
      frontImage: shrisnaImage,
      frontName: "Shrisna Thapa",
      frontTitle: "Vice-President",
      backText: (
        <>
          <span className="back-text">Shrisna Thapa</span>
          {/* <span className="back-text">"Quote"</span> */}
          { <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/shrisna-thapa-893947264/"
              target="_blank"
              rel="noopener noreferrer"
              className="icons linkedin"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=8808&format=png&color=FFFFFF"
                  alt="LinkedIn Icon"
                />
              </div>
              <span>LinkedIn</span>
            </a>

            <a
              href="mailto:shrisna@kalpabriksha.org.np"
              target="_blank"
              rel="noopener noreferrer"
              className="icons email"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=OumT4lIcOllS&format=png&color=000000"
                  alt="Email Icon"
                />
              </div>
              <span>Email</span>
            </a>
          </div> }
        </>
      ),
    },
    {
      id: 3,
      frontImage: abhinabImage,
      frontName: "Abhinab Khanal",
      frontTitle: "General Secretary",
      backText: (
        <>
          <span className="back-text">Abhinab Khanal</span>
          {/* <span className="back-text">"Quote"</span> */}
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/abhinab-khanal-336059257/"
              target="_blank"
              rel="noopener noreferrer"
              className="icons linkedin"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=8808&format=png&color=FFFFFF"
                  alt="LinkedIn Icon"
                />
              </div>
              <span>LinkedIn</span>
            </a>

            <a
              href="mailto:abhinab@kalpabriksha.org"
              target="_blank"
              rel="noopener noreferrer"
              className="icons email"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=OumT4lIcOllS&format=png&color=000000"
                  alt="Email Icon"
                />
              </div>
              <span>Email</span>
            </a>
          </div>
        </>
      ),
    },
    {
      id: 4,
      frontImage: ronikImage,
      frontName: "Ronik Basnet",
      frontTitle: "Secretary",
      backText: (
        <>
          <span className="back-text">Ronik Basnet</span>
          {/* <span className="back-text">"Quote"</span> */}
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/ronik-basnet-69b327217/"
              target="_blank"
              rel="noopener noreferrer"
              className="icons linkedin"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=8808&format=png&color=FFFFFF"
                  alt="LinkedIn Icon"
                />
              </div>
              <span>LinkedIn</span>
            </a>

            <a
              href="mailto:ronikbasnet@kalpabrikshanepal.org.np"
              target="_blank"
              rel="noopener noreferrer"
              className="icons email"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=OumT4lIcOllS&format=png&color=000000"
                  alt="Email Icon"
                />
              </div>
              <span>Email</span>
            </a>
          </div>
        </>
      ),
    },
    {
      id: 5,
      frontImage: shekharImage,
      frontName: "Shekhar Thapa",
      frontTitle: "Treasurer",
      backText: (
        <>
          <span className="back-text">Shekhar Thapa</span>
          {/* <span className="back-text">"Quote"</span> */}
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/shekhar-thapa-7810732aa/"
              target="_blank"
              rel="noopener noreferrer"
              className="icons linkedin"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=8808&format=png&color=FFFFFF"
                  alt="LinkedIn Icon"
                />
              </div>
              <span>LinkedIn</span>
            </a>

            <a
              href="mailto:shekhar@kalpabrikshanepal.org.np"
              target="_blank"
              rel="noopener noreferrer"
              className="icons email"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=OumT4lIcOllS&format=png&color=000000"
                  alt="Email Icon"
                />
              </div>
              <span>Email</span>
            </a>
          </div>
        </>
      ),
    },
    {
      id: 6,
      frontImage: vijayaImage,
      frontName: "Vijaya Sharma",
      frontTitle: "Executive",
      backText: (
        <>
          <span className="back-text">Vijaya Laxmi Sharma</span>
          {/* <span className="back-text">"Quote"</span> */}
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/vijaya-laxmi-sharma/"
              target="_blank"
              rel="noopener noreferrer"
              className="icons linkedin"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=8808&format=png&color=FFFFFF"
                  alt="LinkedIn Icon"
                />
              </div>
              <span>LinkedIn</span>
            </a>

            <a
              href="mailto:vijaya@kalpabrikshanepal.org.np"
              target="_blank"
              rel="noopener noreferrer"
              className="icons email"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=OumT4lIcOllS&format=png&color=000000"
                  alt="Email Icon"
                />
              </div>
              <span>Email</span>
            </a>
          </div>
        </>
      ),
    },
    
    {
      id: 7,
      frontImage: ashleshaImage,
      frontName: "Ashlesha Shrestha",
      frontTitle: "Executive",
      backText: (
        <>
          <span className="back-text">Ashlesha Shrestha</span>
          {/* <span className="back-text">"Quote"</span> */}
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/shrestha-ashlesha/"
              target="_blank"
              rel="noopener noreferrer"
              className="icons linkedin"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=8808&format=png&color=FFFFFF"
                  alt="LinkedIn Icon"
                />
              </div>
              <span>LinkedIn</span>
            </a>

            <a
              href="mailto:ashlesha@kalpabrikshanepal.org.np"
              target="_blank"
              rel="noopener noreferrer"
              className="icons email"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=OumT4lIcOllS&format=png&color=000000"
                  alt="Email Icon"
                />
              </div>
              <span>Email</span>
            </a>
          </div>
        </>
      ),
    },
    {
      id: 8,
      frontImage: siddhantImage,
      frontName: "Siddhant Silwal",
      frontTitle: "Executive",
      backText: (
        <>
          <span className="back-text">Siddhant Silwal</span>
          {/* <span className="back-text">"Quote"</span> */}
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/siddhant-silwal-91a00b24b/"
              target="_blank"
              rel="noopener noreferrer"
              className="icons linkedin"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=8808&format=png&color=FFFFFF"
                  alt="LinkedIn Icon"
                />
              </div>
              <span>LinkedIn</span>
            </a>

            <a
              href="mailto:siddhant@kalpabrikshanepal.org.np"
              target="_blank"
              rel="noopener noreferrer"
              className="icons email"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=OumT4lIcOllS&format=png&color=000000"
                  alt="Email Icon"
                />
              </div>
              <span>Email</span>
            </a>
          </div>
        </>
      ),
    },
    {
      id: 9,
      frontImage: nirojImage,
      frontName: "Niroj Neupane",
      frontTitle: "Executive",
      backText: (
        <>
          <span className="back-text">Niroj Neupane</span>
          <span className="back-text">"Shaktimaan Shaktimaan"</span>
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/niroj-neupane-khatri-39a282339/"
              target="_blank"
              rel="noopener noreferrer"
              className="icons linkedin"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=8808&format=png&color=FFFFFF"
                  alt="LinkedIn Icon"
                />
              </div>
              <span>LinkedIn</span>
            </a>

            <a
              href="mailto:knirojneupane@kalpabriksha.org"
              target="_blank"
              rel="noopener noreferrer"
              className="icons email"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=OumT4lIcOllS&format=png&color=000000"
                  alt="Email Icon"
                />
              </div>
              <span>Email</span>
            </a>
          </div>
        </>
      ),
    },
    {
      id: 10,
      frontImage: niharikaImage,
      frontName: "Niharika Parajuli",
      frontTitle: "Executive",
      backText: (
        <>
          <span className="back-text">Niharika Parajuli</span>
          {/* <span className="back-text">"Quote"</span> */}
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/niharika-parajuli-a98715362/"
              target="_blank"
              rel="noopener noreferrer"
              className="icons linkedin"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=8808&format=png&color=FFFFFF"
                  alt="LinkedIn Icon"
                />
              </div>
              <span>LinkedIn</span>
            </a>

            <a
              href="mailto:niharika@kalpabriksha.org"
              target="_blank"
              rel="noopener noreferrer"
              className="icons email"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=OumT4lIcOllS&format=png&color=000000"
                  alt="Email Icon"
                />
              </div>
              <span>Email</span>
            </a>
          </div>
        </>
      ),
    },
    {
      id: 11,
      frontImage: blankImage,
      frontName: "Vacant Position",
      frontTitle: "Executive",
      backText: (
        <>
          <span className="back-text">Vacant</span>
          {/* <span className="back-text">"Quote"</span> */}
          {/* <div className="social-icons">
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="icons linkedin"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=8808&format=png&color=FFFFFF"
                  alt="LinkedIn Icon"
                />
              </div>
              <span>LinkedIn</span>
            </a>

            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="icons email"
            >
              <div>
                <img
                  src="https://img.icons8.com/?size=100&id=OumT4lIcOllS&format=png&color=000000"
                  alt="Email Icon"
                />
              </div>
              <span>Email</span>
            </a>
          </div> */}
        </>
      ),
    },
  ];


  const absoluteBODImageUrl = "https://www.kalpabriksha.org/images/bod.jpg"; 
  return (
    <div>
      <Helmet>
        <title>Board of Directors | Kalpabriksha Nepal</title>
        <meta name="description" content="Meet the dedicated Board of Directors leading Kalpabriksha Nepal's mission for youth empowerment and development." />
        <meta name="keywords" content="Kalpabriksha, Board of Directors, executive team, Nepal youth leadership, NGO team" />

        <meta property="og:title" content="Board of Directors | Kalpabriksha Nepal" />
        <meta property="og:description" content="Get to know the individuals steering Kalpabriksha Nepal towards its goals of youth upliftment." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://kalpabriksha.org/bod" />
        <meta property="og:image" content={absoluteBODImageUrl} />
      </Helmet>

      <Navbar />
      <HeaderSeparator
        title="Board of Directors"
        breadcrumb={[
          { name: "Home", link: "/" },
          { name: "Board of Directors" },
        ]}
      />
      <div className="bod-container container">
        <h3 className="bod-heading">
          Meet the executive team behind every Kalpabriksha operation for year 2082-84.
        </h3>
        <div className="row bod-grid">
          {teamMembers.map((member, index) => (
            <div className="col-md-3 col-sm-6 mb-4" key={member.id}>
              <FlippingCard
                frontImage={member.frontImage}
                frontName={member.frontName}
                frontTitle={member.frontTitle}
                backText={member.backText}
                isFlipped={flippedCardIndex === index}
                handleFlip={() => handleFlip(index)}
              />
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BOD;